import React from 'react';
import { cn } from '../../../utils/cn';

/**
 * Difficulty color helper
 */
export const getDifficultyColor = (level: number): string => {
  if (level <= 1) return 'bg-green-500';
  if (level <= 2) return 'bg-green-400';
  if (level <= 3) return 'bg-yellow-500';
  if (level <= 4) return 'bg-orange-500';
  return 'bg-red-500';
};

export const DotRating: React.FC<{
  value: number;
  max?: number;
  activeColor: string;
  label: string;
}> = ({ value, max = 5, activeColor, label }) => (
  <div className="flex items-center gap-1" role="img" aria-label={`${label}: ${value} z ${max}`}>
    {Array.from({ length: max }, (_, i) => (
      <div
        key={i}
        className={cn(
          'w-1.5 h-1.5 rounded-full',
          i < value ? activeColor : 'bg-gray-200 dark:bg-zinc-700',
        )}
      />
    ))}
  </div>
);
